import { h, render } from 'preact';
import { EditGiftBox } from './index';
/**
 * Imperatively open the "Edit Gift Box" offcanvas drawer for a given gift box
 * line item.
 */ export const openEditGiftBox = (itemKey, opts = {})=>{
    var _machine_send, _machine_send1;
    const machine = window.__offcanvasMachine;
    const drawer = document.querySelector('.js-offcanvas[data-drawer-names="gift-wrapping"]');
    if (!drawer) {
        console.warn('gift-wrapping drawer element not found in the DOM');
        return;
    }
    // Find the render target inside the drawer
    let target = drawer.querySelector('.js-edit-gift-box-root');
    if (!target) {
        target = document.createElement('div');
        target.className = 'js-edit-gift-box-root';
        const content = drawer.querySelector('.Offcanvas-content') || drawer;
        content.appendChild(target);
    }
    const cleanup = ()=>{
        var _machine_send, _machine_send1;
        try {
            render(null, target);
        } catch (_) {
        // ignore
        }
        machine === null || machine === void 0 ? void 0 : (_machine_send = machine.send) === null || _machine_send === void 0 ? void 0 : _machine_send.call(machine, {
            type: 'collapse',
            drawerName: 'gift-wrapping'
        });
        if (window.location.href.includes('cart')) {
            return;
        }
        machine === null || machine === void 0 ? void 0 : (_machine_send1 = machine.send) === null || _machine_send1 === void 0 ? void 0 : _machine_send1.call(machine, {
            type: 'expand',
            drawerName: 'cart'
        });
    };
    var _opts_giftboxProducts, _opts_giftboxDefaultImage;
    render(h(EditGiftBox, {
        itemKey,
        giftboxProducts: (_opts_giftboxProducts = opts.giftboxProducts) !== null && _opts_giftboxProducts !== void 0 ? _opts_giftboxProducts : null,
        giftboxDefaultImage: (_opts_giftboxDefaultImage = opts.giftboxDefaultImage) !== null && _opts_giftboxDefaultImage !== void 0 ? _opts_giftboxDefaultImage : null,
        onClose: cleanup
    }), target);
    machine === null || machine === void 0 ? void 0 : (_machine_send = machine.send) === null || _machine_send === void 0 ? void 0 : _machine_send.call(machine, {
        type: 'collapse',
        drawerName: 'cart'
    });
    machine === null || machine === void 0 ? void 0 : (_machine_send1 = machine.send) === null || _machine_send1 === void 0 ? void 0 : _machine_send1.call(machine, {
        type: 'expand',
        drawerName: 'gift-wrapping'
    });
};
